// Split a system prompt into navigable sections on its "=== Heading ===" marker
// lines (the Priorität blocks every mode prompt uses). Presentation-only: every
// non-marker line survives verbatim and in order — the marker lines become the
// section headings. Text before the first marker is the preamble (heading "").

export interface PromptSection {
  heading: string;
  text: string;
}

const MARKER = /^===\s*(.+?)\s*===\s*$/;

export function splitPromptSections(prompt: string): PromptSection[] {
  const sections: PromptSection[] = [];
  let heading = "";
  let buf: string[] = [];
  const flush = () => {
    const text = buf.join("\n");
    if (heading || text.trim()) sections.push({ heading, text });
  };
  for (const line of prompt.split("\n")) {
    const m = MARKER.exec(line);
    if (m) {
      flush();
      heading = m[1];
      buf = [];
    } else {
      buf.push(line);
    }
  }
  flush();
  return sections;
}
